/* Literal hex values are the one allowed exception to "tokens only" — they
   describe brand identity that the Fluent token system can't represent (custom
   gradients, sub-brand accents). Mirrors the same constants the CustomerSuccess
   Portal exposes so the two products read as one family. */

export const brandColors = {
  // Transformr family — same values as CustomerSuccessPortal/src/theme/brandColors.ts
  blue: '#0066B2',          // primary CTA
  darkBlue: '#2E3191',      // gradient start, admin/enterprise contexts
  lightBlue: '#56ADDF',     // gradient end, info accents
  navy: '#011338',          // executive-briefing hero / deepest brand tone
  red: '#FF0000',
  orange: '#D9782D',
  yellow: '#F1B934',
  purple: '#9E1F63',
  green: '#95C43E',         // success, feature dots
  grey: '#A6A8AB',
  greyLine: '#E8E8E8',      // hairline borders / bar tracks on white
  greyText: '#6B6B6B',      // muted metadata text
  black: '#000000',
  white: '#FFFFFF',
  darkGrey: '#424242',
} as const;

/* Executive-briefing type system (loaded via the Google Fonts <link> in index.html).
   Heading = Plus Jakarta Sans, body = Inter, mono = JetBrains Mono (ids, metrics). */
export const brandFonts = {
  heading: "'Plus Jakarta Sans', 'Segoe UI', system-ui, sans-serif",
  body: "'Inter', 'Segoe UI', system-ui, sans-serif",
  mono: "'JetBrains Mono', 'Cascadia Code', Consolas, monospace",
} as const;
